export default [
  {
    name: "Лондон",
    utc: "UTC+0",
    timezone: "Europe/London"
  },
  {
    name: "Амстердам/Берлин/Рим",
    utc: "UTC+1",
    timezone: "Europe/Rome"
  },
  {
    name: "Калининград",
    utc: "UTC+2",
    timezone: "Europe/Kaliningrad"
  },
  {
    name: "Москва/Санкт-Петербург/Волгоград",
    utc: "UTC+3",
    timezone: "Europe/Moscow"
  },
  {
    name: "Самара/Ижевск",
    utc: "UTC+4",
    timezone: "Europe/Samara"
  },
  {
    name: "Екатеринбург/Пермь",
    utc: "UTC+5",
    timezone: "Asia/Yekaterinburg"
  },
  {
    name: "Омск",
    utc: "UTC+6",
    timezone: "Asia/Omsk"
  },
  {
    name: "Красноярск",
    utc: "UTC+7",
    timezone: "Asia/Krasnoyarsk"
  },
  {
    name: "Иркутск",
    utc: "UTC+8",
    timezone: "Asia/Irkutsk"
  },
  {
    name: "Якутск",
    utc: "UTC+9",
    timezone: "Asia/Yakutsk"
  },
  {
    name: "Владивосток",
    utc: "UTC+10",
    timezone: "Asia/Vladivostok"
  },
  {
    name: "Магадан",
    utc: "UTC+11",
    timezone: "Asia/Magadan"
  },
  {
    name: "Камчатка",
    utc: "UTC+12",
    timezone: "Asia/Kamchatka"
  }
];
